import React from 'react';
import classNames from 'classnames';
import './Search.scss';
import FontAwesomeIcon from '../Icon';

const Search = ({ size, theme, style={}, containerStyle={}, ...props }) => (
  <div
    className={
      classNames(
        'search',
        {
          [`search--${theme}`]: theme,
          [`search--${size}`]: size,
        }
      )
    }
    style={containerStyle}
  >
    <input
      type="text"
      className="search__control"
      style={style}
      {...props}
    />
    <div className="search__icon">
      <FontAwesomeIcon
        weight="solid"
        glyph="search"
      />
    </div>
  </div>
);

export default Search;
